import type { GetRoadmapDetail200CoursesItem } from './getRoadmapDetail200CoursesItem';
import type { GetRoadmapDetail200Summary } from './getRoadmapDetail200Summary';

export type GetRoadmapDetail200 = {
  /**
   * 로드맵 상세 내용 (Markdown 등)
   * @nullable
   */
  content?: string | null;
  /**
   * 로드맵에 포함된 강의 목록
   * @nullable
   */
  courses: GetRoadmapDetail200CoursesItem[] | null;
  /** 로드맵 기본 요약 정보 */
  summary: GetRoadmapDetail200Summary;
};
